import { MapTo } from '@adobe/aem-react-editable-components';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import { MappedAEMProperties } from '../../../../types';
import Separator from './Separator';

const RESOURCE_TYPE = 'learning-academy/components/custom/separator';

const SeparatorEmptyFn = (props: MappedAEMProperties) => !props;

const EditConfig = {
  emptyLabel: 'Separator',
  isEmpty: SeparatorEmptyFn,
};

export default MapTo<MappedAEMProperties>(RESOURCE_TYPE)(...WithEmptyPlaceholder(Separator, EditConfig));
